import '@tnn/ui/styles.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { apps } from '@tnn/core'
import { createI18n } from '@tnn/i18n'
import { UiProvider } from '@tnn/ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { ScreenPage } from './screen'

/**
 * The portable screen (screen.<domain>), apart from Thananan OS: one page, an app of its own to install on a tablet or
 * phone (public/manifest.webmanifest), with no sign-in, PIN or service worker, and only the screen's endpoints behind it
 * (Caddyfile). Its words are the common `screen.*`, which app-kit's pairing dialog shares
 */

const i18n = createI18n()
// Asked again as the tablet comes back on, in case it missed being told while it slept
const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000 } } })
// It stays open all day: a part of the page left from before a deploy is no longer there, so the new one loads
window.addEventListener('vite:preloadError', () => window.location.reload())

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <UiProvider seed={apps.portal.seed} locale="th" closeLabel={i18n.t('actions.close')} forceColorScheme="light">
          <ScreenPage />
        </UiProvider>
      </I18nextProvider>
    </QueryClientProvider>
  </StrictMode>,
)
